import { Help } from '@project-lary/react-material-symbols';
import type React from 'react';
import type { PropsWithChildren } from 'react';
import { cn } from '../utils/tailwind-merge';
import { Tooltip, TooltipContent, TooltipTrigger } from './tooltip';

type TooltipProps = PropsWithChildren<{
  Icon?: React.ElementType;
  className?: string;
}>;

function IconTooltip({ Icon, children, className }: TooltipProps) {
  const IconToBeRendered = Icon ?? Help;
  return (
    <Tooltip>
      <TooltipTrigger
        className="flex items-center"
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
        }}
      >
        <IconToBeRendered className={cn('text-md text-neutral-alpha-11 hover:text-neutral-12', className)} />
      </TooltipTrigger>
      <TooltipContent className="text-left">{children}</TooltipContent>
    </Tooltip>
  );
}

export default IconTooltip;
